var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("No se encontro el recurso")]),_c('p',[_vm._v("Vuelva a la pagina anterior")])])}]

export { render, staticRenderFns }